/**
 * Created by zzy on 2019/8/5.
 */
import FireFightingSystem from './FireFightingSystem.vue'
export default FireFightingSystem



// WEBPACK FOOTER //
// ./src/views/monitoring/fireFightingSystem/index.js